import { render, staticRenderFns } from "./todayClass.vue?vue&type=template&id=dbc336e0&scoped=true"
import script from "./todayClass.vue?vue&type=script&lang=js"
export * from "./todayClass.vue?vue&type=script&lang=js"
import style0 from "./todayClass.vue?vue&type=style&index=0&id=dbc336e0&prod&scoped=true&lang=scss"
import style1 from "./todayClass.vue?vue&type=style&index=1&id=dbc336e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc336e0",
  null
  
)

export default component.exports